import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const WeatherSunFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function WeatherSunFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12ZM13.5 0h-3v4h3V0ZM13.5 20h-3v4h3v-4ZM24 10.5h-4v3h4v-3ZM4 10.5H0v3h4v-3ZM18.715 16.595l-2.12 2.121 2.828 2.829 2.12-2.121-2.828-2.829ZM4.579 2.455 2.457 4.576l2.829 2.829 2.121-2.121-2.828-2.829ZM5.284 16.594l-2.828 2.828 2.121 2.121 2.828-2.828-2.12-2.121ZM19.424 2.457l-2.828 2.828 2.121 2.121 2.828-2.828-2.12-2.121Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default WeatherSunFilled;